import React from "react";

import './TitleName.css';

const titleName = () => <p className='TitleName'>Vladislav Il'govskiy</p>;

export default titleName;
